import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b60bfa80"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "error" }
const _hoisted_2 = { class: "error-content" }

import { toRefs, withDefaults } from 'vue'

  interface Props {
    title: string
    message: string
    buttonText: string
    path?: string
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    message: null,
    buttonText: null,
    path: { default: '/' }
  },
  setup(__props: any) {

const props = __props as { title: string, message: string, buttonText: string, path: string }

  
  const { buttonText, title, message, path } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", null, _toDisplayString(_unref(title)), 1),
      _createElementVNode("p", null, _toDisplayString(_unref(message)), 1),
      (_unref(buttonText))
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push(_unref(path)))),
            class: "upper"
          }, _toDisplayString(_unref(buttonText)), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})